import _ from 'underscore';
import Backbone from 'backbone';
import Localizer from 'localizer';
import ModalPopupView from 'views/main/Modal/ModalPopupView';
import templateHtml from 'templates/main/Modal/ModalConfirmationView.html';

var MessageView = Backbone.View.extend({
    template: _.template(templateHtml),

    initialize: function(args) {
        this.message = args.message;

        this.message2 = args.message2;

        this.htmlFormat = args.htmlFormat;

        this.showCloseButton = args.showCancelButton;
    },

    render: function() {
        this.$el.html(
            this.template({
                message: this.message,
                message2: this.message2,
                htmlFormat: this.htmlFormat
            })
        );
    }
});

var ModalConfirmationView = ModalPopupView.extend({
    initialize: function(args) {
        if (!args.message) {
            throw 'Message required for ModalConfirmationView';
        }

        args.view = new MessageView({
            message: args.message,

            message2: args.message2 || null,

            /* Set htmlFormat to true if we need to display html content */
            htmlFormat: args.htmlFormat ? true : false,
            showCloseButton: args.showCancelButton ? args.showCancelButton : true
        });

        ModalPopupView.prototype.initialize.call(this, args);
    }
});

export default ModalConfirmationView;
